const routeUrls = (type, id) => {
  if (type === "category") return `/categories/${id}`;
  else if (type === "zhuanlan") return `/zhuanlans/${id}`;
  else if (type === "testpaper") return `/testpaper/${id}`;
  else if (type === "testpaper_collection")
    return `/testpaper_collection/${id}`;
};

export default routeUrls;
